import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

type NumericFontProps = {
  value?: string;
  className?: string;
};

export const NumericFont: FC<NumericFontProps> = ({ value, className }) => {
  if (!value) return null;
  return (
    <span className={classnames(styles.container, className)}>
      {value?.split('').map((char, i) =>
        char <= '9' && char >= '0' ? (
          <span key={`${i}-${char}`}>{char}</span>
        ) : (
          <span key={`${i}-${char}`} className={styles.letter}>
            {char}
          </span>
        )
      )}
    </span>
  );
};
